module.exports = __webpack_public_path__ + "img/left-flag.2cdc6b0d.svg";